import SedanEn from "./sedan-en.png";
import SedanFr from "./sedan-fr.png";
import SuvEn from "./suv-en.png";
import SuvFr from "./suv-fr.png";
import TruckEn from "./truck-en.png";
import TruckFr from "./truck-fr.png";

export { SedanEn, SedanFr, SuvEn, SuvFr, TruckEn, TruckFr };
